export const ReactModalStyles = {
    overlay: {
        backgroundColor: 'rgb(53, 61, 48, 0.75)'
    } 
};
